import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select as MuiSelect } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';

export default function MySelect(props) {

  const { name, label, value, error = null, disabled, onChange, options } = props;

  return (
    <Box sx={{ marginTop: 1, marginBottom: 0.4 }}>
      <FormControl
        variant="outlined"
        fullWidth
        size="small"
        {...(error && { error: true })}>
        <InputLabel id={`${name}-label`} shrink={value !== null && value !== ''}>{label}</InputLabel>
        <MuiSelect
          labelId={`${name}-label`}
          id={name}
          label={label}
          name={name}
          value={value ?? ''}
          disabled={disabled}
          onChange={onChange}
        >
          {Array.isArray(options) ? (
            options.map(item => {
              if (item && item.id !== undefined && item.title !== undefined) {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.title}
                  </MenuItem>
                );
              } else {
                console.error('Invalid option item:', item);
                return null;
              }
            })
          ) : (
            console.error('Options is not an array:', options)
          )}
        </MuiSelect>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Box>
  )
}